<template>
  <div class="no-result flex flex-col justify-center items-center text-gray-80 h-504px">
    <etg-img :src="noResultImage" alt="no-result" class="w-74px h-100px" />
    <p class="text-center text-base flex flex-col items-center mt-5 gap-1">
      <slot />
    </p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  imagePath?: string
}>()

const noResultImage = props.imagePath || '/images/empty-table.svg'
</script>
